<template>
  <div class="listGroup">
    <div class="listGroup__header">
      <div class="listGroup__header__left">
        <h2 class="listGroup__header__left__title small-title">
          {{title | capitalizing}}
        </h2>
        <span class="subhead">{{count}} Item</span>
      </div>
      <div class="listGroup__header__right">

      </div>
    </div>
    <div class="listGroup__listings">
      <div class="listview">
        <table>
          <thead class="none">
            <tr>
              <td class="listview__title items">ITEMS</td>
              <td class="listview__title placement">PLACEMENT</td>
              <td class="listview__title dailyvisitor">DAILY VISITOR</td>
              <td class="listview__title price">PRICE / DAY</td>
              <td class="action" v-if="isAction"></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in itemList" :key="index" @click.stop="listClick(item)" class="content">
              <td class="items">
                <div class="item">
                  <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="title">{{item.location_name}}</span>
                    <span class="location">
                      {{item.property_type_display}} . {{item.city_name}}
                    </span>
                    <span class="price-mobile">{{item.price | formatMoney}}</span>
                  </div>
                </div>
              </td>
              <td class="placement none"><span>{{item.placement}}</span></td>
              <td v-if="item.is_audience_displayed" class="visitor none"><span>{{item.audience_daily}} people</span></td>
              <td v-else class="visitor none">-</td>
              <td class="price none"><span>{{item.price | formatMoney}}</span></td>
              <td class="menu-action" @click.stop>
                <adx-tooltip :text="tooltipText(item.id)">
                  <div slot="content" class="icon-list" @click.stop="addRemoveDevice(item)">
                    <adx-loading-secondary v-if="isLoading.includes(item.id)" />
                    <i v-if="!isLoading.includes(item.id)" :class="iconSelection(item.id)"></i>
                  </div>
                </adx-tooltip>
                <menu-expansion :itemID="item.id" @selected="selected" :lists="menuList" />
              </td>
            </tr>
            <tr v-if="isShowMore" @click="isShowMore = false; allShown = true;">
              <td colspan="5" class="show-more"> <span> Show More </span> </td>
            </tr>
          </tbody>
        </table>
        <div class="emptyState">
          <adx-empty-selection v-if="isEmpty"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuExpansion from '@/components/MenuExpansion'
import Alert from '@/components/Alert'
import LoadingSecondary from '@/components/Loading/Secondary'
import EmptySelection from '@/components/NotFound/Selection'
import Tooltip from '@/components/Tooltip'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-list-group',
  components: {
    'menu-expansion': MenuExpansion,
    'adx-alert': Alert,
    'adx-loading-secondary': LoadingSecondary,
    'adx-empty-selection': EmptySelection,
    'adx-tooltip': Tooltip
  },
  props: {
    items: {
      required: false
    },
    headers: {
      required: false
    },
    category: {
      required: false
    },
    menuList: {
      required: false
    },
    page: {
      required: false
    },
    isAction: {
      required: false
    },
    loading: {
      required: false
    },
    title: {
      required: false
    },
    count: {
      required: false
    }
  },
  data() {
    return {
      isHover: null,
      isEmpty: false,
      lists: [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "S",
          "items": [
            {
              "name": "Create new saved"
            },
            {
              "name": "Saved Gaul"
            },
            {
              "name": "Saved Konser"
            },
            {
              "name": "Saved Nobar"
            },
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "AP",
          "items": [
            {
              "name": "Create new campaign"
            },
            {
              "name": "Gaul"
            },
            {
              "name": "Konser"
            },
            {
              "name": "Nobar"
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "KO"
        },
        {
          "id": 3,
          "name": "More from this brand",
          "value": "Mo"
        }
      ],
      saved: [],
      isLoading: [],
      isShowMore: false,
      allShown: false
    }
  },
  computed: {
    itemList() {
      if (this.items.length > 10 && !this.allShown) {
        this.isShowMore = true
        return this.items.slice(0, 10)
      }
      return this.items
    },
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    addRemoveDevice(item) {
      (async () => {
        this.isLoading.push(item.id)
        let category = this.title.toLowerCase()
        const isLogin = this.token

        if(isLogin) {
          const { response, msg } = await this.$store.dispatch('addRemoveSaved', {item: item, category: category})

          this.$notify({
            group: 'saved',
            title: msg.title,
            text: msg.text,
            type: msg.type
          });

          this.isLoading = []
        }else {
          const currentRoute = this.$route.path
          this.$router.push({name: 'signin', query: { next: currentRoute }})
        }

      })();

    },
    iconSelection(id) {
      const listSaved = this.defaultSaved[this.title.toLowerCase()]
      const isLogin = this.token

      if(isLogin && listSaved) {
        if (listSaved.includes(id)) {
          return 'adx-ic_check'
        } else {
          return 'adx-ic_plus'
        }
      } else {
        return 'adx-ic_plus'
      }


    },
    setID(id){

    },
    selected(menuObject) {
      if (menuObject.value == 'saved') {
        let category = this.category
        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'device'
        }
        if (menuObject.items.value !== 0) {
          let data = {
              'target_id': menuObject.items.value,
              [category]: menuObject.item_id
          };
          (async () => {
            const response = await api.patch(apiV2.savedCopy, data, { needToken: true })
            if (response.status == 200) {
              let item = this.items.filter(value => {
                return value.id == menuObject.item_id
              })[0]
              let saved = this.menuList[0].items.filter(obj => {
                return obj.value == menuObject.items.value
              })[0]
              this.$notify({
                group: 'saved',
                title: 'Added to saved',
                text: item.location_name + ' has been added to ' + saved.name + ' folder',
                type: 'success'
              });
            }else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: 'sorry something went wrong!',
                type: 'warn'
              });
            }
          })();
        } else {
          const params = {
            [category+'s']: [menuObject.item_id]
          }
          this.$emit('createNew', params)
        }
      } else if (menuObject.value == 'detail') {
        let item = this.items.filter(value => {
          return value.id == menuObject.item_id
        })[0]
        this.listClick(item)
      } else if (menuObject.value == 'campaign'){
        let category = this.category
        const devices = ['lifestyle', 'malls', 'spbu', 'airport']
        if (devices.includes(category)) {
          category = 'idooh'
        }
        if (menuObject.items.value !== 0) {
          let data = {
              'channel_id': menuObject.item_id,
              'channel_name': category
          };
          (async () => {
            const response = await api.patch(apiV2.campaignAddListing(menuObject.items.value), data, { needToken: true })
            if (response.status == 200) {
              let item = this.items.filter(value => {
                return value.id == menuObject.item_id
              })[0]
              let campaign = this.menuList[1].items.filter(obj => {
                return obj.value == menuObject.items.value
              })[0]
              this.$notify({
                group: 'saved',
                title: 'Added to campaign',
                text: item.location_name + ' has been added to ' + campaign.name,
                type: 'success'
              });
            }else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: 'sorry something went wrong!',
                type: 'warn'
              });
            }
          })();
        } else {
          let item = this.items.filter(value => {
            return value.id == menuObject.item_id
          })[0]
          const params = {
            category: category,
            device_id: menuObject.item_id,
            location_name: item.location_name
          }
          this.$emit('createNewCampaign', params)
        }
      }
    },
    listClick(item) {
      let routeData
      if(item.category_display == 'spbu'){
        routeData =  this.$router.resolve({name: 'detailspbu', params: {pub_id : item.pub_id}})
      }
      if(item.category_display == 'lifestyle'){
        routeData =  this.$router.resolve({name: 'detaillifestyle', params: {pub_id : item.pub_id}})
      }
      if(item.category_display == 'malls'){
        routeData =  this.$router.resolve({name: 'detailmall', params: {pub_id : item.pub_id}})
      }
      if(item.category_display == 'airport'){
        routeData =  this.$router.resolve({name: 'detailairport', params: {pub_id : item.pub_id}})
      }
      window.open(routeData.href, '_blank')
    },
    tooltipText(id) {
      const listSaved = this.defaultSaved[this.title.toLowerCase()]
      if(listSaved){
        if (listSaved.includes(id)) {
          return `remove saved`
        } else {
          return `add to saved`
        }
      }else {
        return `add to saved`
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

